import React from 'react';
import CustomForm from './customForm';
import Carousels from './carousel';
import Footer from './footer';
import Navbars from './Navbar';

const Import = () => {
  const handleFormSubmit = async (formData) => {
    try {
      const response = await fetch('/eicimobility/importResult', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        hawbNo: formData.hawbNo,
        courierName: formData.courierCompany
        }) 
      });
      if (!response.ok) {
        return {
          status: 'FAILURE',
          errorMessage: 'Failed to fetch data from server.',
        };
      }
      const data = await response.json();
      return data; 
    } catch (error) {
      return {
        status: 'FAILURE',
        errorMessage: 'Network error or unexpected issue occurred.',
      };
    }
  };

  return (
<div className="container-fixed">
<Navbars />
<Carousels />
<CustomForm title="Import" 
            onSubmit={handleFormSubmit} 
            navigateTo="/importresult"/>
<Footer />
</div>
);
};
export default Import;

 